import { useContext, useEffect } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import * as Layouts from "./Layouts";
import { UserContext } from "./context";
import { initApp, showSpinner } from "./handlers";
import { Login, Menu } from "./screens";
import NotFound from "./screens/NotFound";
import Podadores from "./screens/Admin/Podadores";
import Podador from "./screens/Admin/Podador";
import CreatePodador from "./screens/Admin/Podador/form/form-create";
import Barrios from "./screens/Admin/Barrios";
import Barrio from "./screens/Admin/Barrio";
import CrearBarrio from "./screens/Admin/Barrio/form/create-barrio";
import Especies from "./screens/Admin/Especies";
import CreateEspecie from "./screens/Admin/Especie/form/FormEspecie";
import AdminAppLayout from "./Layouts/AdminAppLayout";
import FormEspecie from "./screens/Admin/Especie/form/FormEspecie";
import Actas from "./screens/Public/Actas";
import ActasAdmin from "./screens/Admin/Actas";
import MenuAdmin from "./screens/Admin/MenuAdmin";
import Home from "./screens/Home";
import InspectorLayout from "./Layouts/InspectorLayout/InspectorLayout";
import ActasInspector from "./screens/Inspector/ActasInspector/ActasInspector";
import CrearSolicitud from "./screens/Public/CrearSolicitud/CrearSolicitud";
import MisSolicitudes from "./screens/Public/MisSolicitudes/MisSolicitudes";
import ListaPodadores from "./screens/Public/ListaPodadores/ListaPodadores";

const App = () => {
  const { actions, loading } = useContext(UserContext);

  useEffect(() => {
    initApp(actions);
  }, []);

  showSpinner(loading);

  /* const NotFound = () => 404; */

  return (
    <HashRouter>
      <Routes>
        <Route element={<Layouts.UserLayout />}>
          <Route element={<AdminAppLayout />}>
            <Route path="/admin" element={<MenuAdmin />} />
            <Route path="/especies" element={<Especies />} />
            <Route path="/especie/:id" element={<FormEspecie type={"update"} />} />
            <Route path="/crear_especie" element={<FormEspecie type={"create"} />} />
            <Route path="/admin/actas" element={<ActasAdmin />} />

            <Route path="/actas" element={<Actas />} />

            <Route path="/podadores" element={<Podadores />} />
            <Route path="/podador/:id" element={<Podador />} />
            <Route path="/crear_podador" element={<CreatePodador />} />

            <Route path="/barrios" element={<Barrios />} />
            <Route path="/barrio/:id" element={<Barrio />} />
            <Route path="/crear_barrio" element={<CrearBarrio />} />
          </Route>

          <Route element={<InspectorLayout />}>
            <Route path="/inspecciones_solicitudes" element={<ActasInspector />} />
          </Route>

          {/* <Route path="/" element={<Menu />} /> */}
          {/* //!SE CAMBIO */}
          <Route path="/" element={<Home />} />
          <Route path="/crear_solicitud" element={<CrearSolicitud />} />
          <Route path="/mis_Solicitudes" element={<MisSolicitudes />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/lista_podadores" element={<ListaPodadores />} />
      </Routes>
    </HashRouter>
  );
};

export default App;
